export const LADE_AUSWAHLWERTE_DOKUMENT = "ladeAuswahlwerteDokument";
